import React, { useState } from 'react'
import { CallToAction, EditButton, Image, SaveButton, SectionContent, SectionHeader, SectionWrapper, SubTitle, Title } from '../HomePage-elements';
import Kapal from '../../../../assets/image/kapal.svg'
import { Form, Formik } from 'formik';
import { FormControl } from '../../../../components';
import { getStyle } from '../../../../utils/helpers/errorMessage';
import API from '../../../../config/api';
import swal from 'sweetalert';
const token = localStorage.getItem('token');
const KarirSection = (props) => {
    const { item, edit, initialValuesKarir, schemaValidationKarir, setLoading, getDataMainSection } = props;
    const [isKarir, setIsKarir] = useState(false);
    const [isEditKarir, setIsEditKarir] = useState(false);
    const [message, setMessage] = useState('');
    const handleSubmit = (values, { resetForm, setSubmitting }) => {
        setLoading(true)

        // data = JSON.stringify(data)
        const data = {
            title: values.title,
            subtitle: values.subtitle,
            description: values.description,
            button_text: values.button_text,
            link: values.link,
            image: values.image,
        }
        console.log(data)



        let formData = new FormData();


        formData.append('title', data.title);
        formData.append('name_section', "Karir Section");
        formData.append('call_to_action', 1);
        formData.append('page_type', 'Home');
        formData.append('subtitle', data.subtitle);
        formData.append('description', data.description);
        formData.append('button_text', data.button_text);
        formData.append('link', data.link);
        formData.append('image', data.image);
        API.EditHomePageMainSection(token, formData, initialValuesKarir.id)
            .then(res => {
                setMessage('Data Dasar Berhasil Ditambahkan');
                swal({
                    title: 'Berhasil',
                    text: `Karir Section Berhasil Diubah`,
                    icon: "success",
                });
                setIsEditKarir(false)
                setSubmitting(false);
                getDataMainSection()
                setLoading(false)
            })
            .catch(err => {
                console.log(err.message);
                setMessage(err.response?.data?.message || 'Terjadi kesalahan');
                swal({
                    title: err.response?.status || 'Error',
                    text: err.response?.data?.message || 'Terjadi kesalahan saat mengunggah data',
                    icon: "error",
                });
                setIsEditKarir(false)
                setLoading(false)
            });
        // if (isAddOrEdit == 'edit') {
        //     // console.log('edit');

        //     let formData = new FormData();
        //     formData.append('_method', 'PUT');
        //     formData.append('name', data.name);
        //     formData.append('short_name', data.short_name);
        //     formData.append('description', data.description);
        //     formData.append('email', data.email);
        //     formData.append('website', data.website);
        //     formData.append('telp', data.telp);
        //     formData.append('business_fields', data.business_fields);
        //     formData.append('address', data.address);
        //     formData.append('logo', data.logo);
        //     // console.log(formData);
        //     axios
        //         .post(url, formData, {
        //             headers: {
        //                 'Content-Type': 'multipart/form-data',
        //                 Authorization: `Bearer ${token}`,
        //             },
        //         })
        //         .then(res => {
        //             console.log(res)
        //             // console.log(res.data.message);
        //             swal({
        //                 title: res.data.status,
        //                 text: res.data.message,
        //                 icon: "success",
        //             });
        //             window.location.reload();

        //         })
        //         .catch(err => {
        //             // console.log(err.response);
        //             console.log(err.response);
        //             swal({
        //                 title: err.status,
        //                 // text: err.response.data.message,
        //                 icon: "error",
        //             });
        //         });
        // } else {
        //     // console.log('add')
        //     let formData = new FormData();


        //     formData.append('name', data.name);
        //     formData.append('short_name', data.short_name);
        //     formData.append('description', data.description);
        //     formData.append('email', data.email);
        //     formData.append('website', data.website);
        //     formData.append('telp', data.telp);
        //     formData.append('business_fields', data.business_fields);
        //     formData.append('address', data.address);
        //     formData.append('logo', data.logo);
        //     axios
        //         .post(url, formData, {
        //             headers: {
        //                 'Content-Type': 'multipart/form-data',
        //                 Authorization: `Bearer ${token}`,
        //             },
        //         })
        //         .then(res => {
        //             // console.log(res)
        //             // console.log(res.data.message);
        //             swal({
        //                 title: res.data.status,
        //                 text: res.data.message,
        //                 icon: "success",
        //             });
        //             window.location.reload();

        //         })
        //         .catch(err => {
        //             // console.log(err.response);
        //             console.log(err.response);
        //             swal({
        //                 title: err.status,
        //                 // text: err.response.data.message,
        //                 icon: "error",
        //             });
        //         });
        // }

        // // resetForm();
        // setSubmitting(false);
        // reloadPage();
        // console.log('simpan pengaturan informasi perusahaan')

    };

    return (
        <SectionWrapper>
            <Formik
                enableReinitialize
                initialValues={initialValuesKarir}
                onSubmit={(values, props) => handleSubmit(values, props)}
                validationSchema={() => schemaValidationKarir}
            >
                {({
                    values,
                    errors,
                    touched,
                    setFieldValue,
                    setFieldTouched,
                    isSubmitting
                }) => (
                    <Form >
                        <SectionHeader onClick={() => setIsKarir(!isKarir)}>
                            Karir
                            {
                                isEditKarir ?
                                    <div>
                                        <EditButton style={{ marginRight: "10px" }}
                                            onClick={(e) => {
                                                e.stopPropagation(); // Prevents the section from toggling when clicking the button
                                                setIsEditKarir(false);
                                            }}
                                        >
                                            Cancel
                                        </EditButton>
                                        <SaveButton
                                            onClick={(e) => {
                                                e.stopPropagation(); // Prevents the section from toggling when clicking the button
                                                setIsEditKarir(true);
                                            }}
                                            type='submit'
                                            disabled={isSubmitting}>
                                            Save
                                        </SaveButton>
                                    </div>

                                    : <SaveButton
                                        onClick={(e) => {
                                            e.stopPropagation(); // Prevents the section from toggling when clicking the button
                                            setIsEditKarir(true);
                                            setIsKarir(true);
                                            edit(item, 'Karir');
                                        }}
                                    >
                                        Edit
                                    </SaveButton>
                            }
                        </SectionHeader>
                        <SectionContent isOpen={isKarir}>
                            {
                                isEditKarir ?

                                    <div className="left-form">

                                        <FormControl control="file" label="image" name="image" fileURL={initialValuesKarir.image || Kapal}
                                            style={getStyle(errors, touched, 'image')}
                                        />
                                        <FormControl control="input" type="text" label="Title" name="title"
                                            style={getStyle(errors, touched, 'title')}
                                        />
                                        <FormControl control="input" type="text" label="subtitle" name="subtitle"
                                            style={getStyle(errors, touched, 'subtitle')}
                                        />
                                        <FormControl control="textarea" type="text" label="description" name="description"
                                            style={getStyle(errors, touched, 'description')}
                                        />
                                        <FormControl control="input" type="text" label="button_text" name="button_text"
                                            style={getStyle(errors, touched, 'button_text')}
                                        />
                                        <FormControl control="input" type="text" label="link" name="link"
                                            style={getStyle(errors, touched, 'link')}
                                        />


                                    </div>
                                    :
                                    <>
                                        <Title>Image</Title>
                                        <Image src={item?.image || Kapal} alt="Karir Image" />
                                        <Title>Title</Title>
                                        <SubTitle>{item?.title}</SubTitle>
                                        <Title>SubTitle</Title>
                                        <SubTitle>{item?.subtitle}</SubTitle>
                                        <Title>Description</Title>
                                        <SubTitle>{item?.description}</SubTitle>
                                        <Title>Call To Action</Title>
                                        <CallToAction href={item?.link}>{item?.button_text} – {item?.link}</CallToAction>
                                    </>
                            }
                        </SectionContent>
                    </Form>
                )}
            </Formik>
        </SectionWrapper >
    )
}

export default KarirSection
